export default {
  dataset: 'production',
  projectId: '8062dlq7',
  useCdn: true,
  apiVersion: '2023-02-01',
};
